// ========= Global Validation for Forms =========
// National Code : insert your value as argument to the function. returns false and a message as helper text.
// Postal Code : insert your value as argument to the function. returns false and a message as helper text.
//IrMobile Number : insert your value as argument to the function. returns false and a message as helper text.

// For validating using hook forms suggest use code below into rules props of Controller ; 
// validate: value => IrMobileValidations(value)


function nationalCodeValidations(nationalId) {
    if ( nationalId.length > 10 || nationalId.length < 10 ) {
        return false || `کد ملی باید 10 رقم باشد`;
    }

    // Check if all of the numbers are the same
    if (
        nationalId == "0000000000" ||
        nationalId == "1111111111" ||
        nationalId == "2222222222" ||
        nationalId == "3333333333" ||
        nationalId == "4444444444" ||
        nationalId == "5555555555" ||
        nationalId == "6666666666" ||
        nationalId == "7777777777" ||
        nationalId == "8888888888" ||
        nationalId == "9999999999"
    ) {
        return false || `کد ملی صحیح نمی باشد`;
    }

    // STEP 00 : if nationalId.lenght==8 add two zero on the left
    if (nationalId.length < 10) {
        let zeroNeeded = 10 - nationalId.length;
        
        let zeroString = "";
        if (zeroNeeded == 2) {
            zeroString = "00";
        } else {
            zeroString = "0";
        }
    
        nationalId = zeroString.concat(nationalId);
    }

    // STEP 1: Sum all numbers
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += nationalId.charAt(i) * (10 - i);
    }

    // STEP 2: MOD ON 11
    let mod = sum % 11;

    // STEP 3: Check with 2
    let finalValue;
    if (mod >= 2) {
        finalValue = 11 - mod;
    } else {
        finalValue = mod;
    }

    // STEP 4: Final Step check with control value
    if (finalValue == nationalId.charAt(9)) {
    
        return true;
    } else {
    
        return false || `کد ملی صحیح نمی باشد`;
    }
}

function postalCodeValidations(value) {
    const pattern = /^[0-9]{10}$/
    return (pattern.test(value)) || ` کدپستی  باید ده رقمی باشد`
}

function irMobileValidations(value) {
    const pattern = new RegExp("^(\\+98|0)?9\\d{9}$");
    return (pattern.test(value)) || `شماره تلفن صحیح نمی باشد`
}

function emailValidations(value) {
    // RFC 5322 email validation standard pattern
    const pattern = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    return (pattern.test(value)) || `ایمیل صحیح نمی باشد`
}

export {
    irMobileValidations,
    postalCodeValidations,
    nationalCodeValidations,
    emailValidations
}